import { connect } from 'react-redux'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import UIkit from 'uikit'

// Components
import ButtonWithLoader from 'app/views/components/ButtonWithLoader'
import Modal from 'app/views/components/UIkit/Modal'

// Containers
import BrowserSkillArea from 'app/views/containers/BrowserSkillArea'

// Redux
import { getContentById } from 'app/state/modules/content'

// Settings
import settings from 'settings'

// Utils
import analytics from 'app/views/utils/analytics'
import { api } from 'app/views/utils/api'
import isMobileDevice from 'app/views/utils/mobile'
import { isEmailValid } from 'app/views/utils/validators'

const propTypes = {}
const defaultProps = {}

class Demo extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      loading: false,
    }

    this.handleClickBack = this.handleClickBack.bind(this)
    this.handleClickCircle = this.handleClickCircle.bind(this)
    this.handleClickNext = this.handleClickNext.bind(this)
    this.handleClickDone = this.handleClickDone.bind(this)
    this.handleClickCreateAccount = this.handleClickCreateAccount.bind(this)
    this.handleChangeEmail = this.handleChangeEmail.bind(this)
    this.handleSubmitEmail = this.handleSubmitEmail.bind(this)
  }

  componentDidMount() {
    this.props.getContentById('demo')
    analytics.page('sql-injection')
  }

  handleClickBack(stepId) {
    analytics.track('Demo - Click Back', { stepId })
  }

  handleClickCircle(stepId) {
    analytics.track('Demo - Click Circle', { stepId })
  }

  handleClickDone(stepId) {
    analytics.track('Demo - Click Done', { stepId })
  }

  handleClickNext(stepId) {
    analytics.track('Demo - Click Next', { stepId })
  }

  handleClickCreateAccount() {
    analytics.track('Demo - Learn More (CTA)')
    this.props.history.push('/secure-development-training')
  }

  handleChangeEmail(event) {
    this.setState({
      email: event.target.value,
    })
  }

  handleSubmitEmail(event) {
    event.preventDefault()

    this.setState({ loading: true })

    if (isEmailValid(this.state.email)) {
      api({
        method: 'post',
        url: `${settings.urls.hacker}/contact`,
        data: {
          message: `${this.state.email} is trying trying the SQL Injection demo`,
        },
      })
        .then(() => {
          UIkit.modal('#modal-test').hide()
          this.setState({ loading: false })
          if (localStorage.getItem('hackedu.tour.lesson') !== 'true') {
            localStorage.setItem('hackedu.tour.lesson', 'true')
            UIkit.modal('#modal-lesson-tour').show()
          }
        })
    } else {
      this.setState({
        loading: false,
        error: 'Email is not valid.',
      })
    }
  }

  render() {
    if (!Object.keys(this.props.contentDetails).includes('demo')) {
      return (
        <div className="uk-section uk-text-center">
          <div className="uk-container">
            <div data-uk-spinner="" />
          </div>
        </div>
      )
    }
    if (isMobileDevice()) {
      return (
        <div className="uk-section">
          <div className="uk-container uk-text-center">
            <h3 className="uk-text-bold">Looks like you are on mobile...</h3>
            <p>
              Thanks for checking out our demo while on the go, but our tools are not available on
              mobile.
            </p>
            <Link className="uk-button uk-button-primary" to="/">Back To Homepage</Link>
          </div>
        </div>
      )
    }
    const content = this.props.contentDetails.demo
    return (
      <div data-test-id="sql-injection-component">
        <Modal
          id="modal-test"
          data-test-id="sql-injection-modal-component"
          titleTestId="title-modal-test"
          title="SQL Injection Demo"
          body={(
            <div className="uk-container uk-container-small uk-text-center">
              <p>
                Thanks for your interest in our demo.
              </p>
              <p>
                Please enter your email before continuing.
              </p>
              <form>
                <div className="uk-margin">
                  <input
                    name="email"
                    type="text"
                    placeholder="Email"
                    className="uk-input"
                    onChange={this.handleChangeEmail}
                  />
                </div>

                {(this.state.error) && (
                  <span className="uk-text-danger">{this.state.error}</span>
                )}

                <div className="uk-margin">
                  <ButtonWithLoader
                    type="submit"
                    className="uk-button uk-button-primary tm-button-primary"
                    isLoading={this.state.loading}
                    onClick={this.handleSubmitEmail}
                  >
                    Submit
                  </ButtonWithLoader>
                </div>
              </form>
            </div>
          )}
          bgClose={false}
          containerModifier
          handleComponentDidMount={() => { UIkit.modal('#modal-test').show() }}
        />
        <BrowserSkillArea
          handleClickBack={(stepId) => { this.handleClickBack(stepId) }}
          handleClickCircle={(stepId) => { this.handleClickCircle(stepId) }}
          handleClickNext={(stepId) => { this.handleClickNext(stepId) }}
          handleClickDone={(stepId) => { this.handleClickDone(stepId) }}
          title={content.title}
          description={content.description}
          steps={content.steps}
          tabs={content.tabs}
          ecsTaskDefinition={content.ecs_task_definition}
          currentProgress={0}
          hasTest={false}
          appType={content.app_type}
          contentType={content.content_type}
          lessonCompletionURL="/register"
          lessonCompletionText="Create an Account"
        />
      </div>

    )
  }
}


Demo.propTypes = propTypes
Demo.defaultProps = defaultProps

const mapStateToProps = state => ({
  // content
  contentDetails: state.content.contentDetails,
})

const mapDispatchToProps = dispatch => ({
  getContentById: contentId => dispatch(getContentById(contentId)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Demo))
